<template>
    <UApp :locale="uiLocale" :tooltip="{ delayDuration: 200 }">
        <component :is="layout">
            <router-view />
        </component>
    </UApp>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { sl } from '@nuxt/ui/locale'

    import Default from '@/layouts/Default.vue'
    import Blank   from '@/layouts/Blank.vue'

    const route = useRoute()

    // Slovenian only (spec decision #14): Nuxt UI's own texts use its `sl` locale.
    const uiLocale = sl

    const layouts = { Default, Blank }
    // Until the first route resolves there is no meta; the frameless layout avoids a flash of the shell.
    const layout  = computed(() => route.matched.length
        ? layouts[(route.meta.layout as keyof typeof layouts) ?? 'Default']
        : Blank)
</script>
